var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1065 0.996582H3.37723C2.73603 0.996582 2.1211 1.2513 1.66771 1.7047C1.21431 2.15808 0.959595 2.77302 0.959595 3.41422V3.90097L12.2419 10.5382L23.5242 3.89775V3.41422C23.5242 2.77302 23.2694 2.15808 22.8161 1.7047C22.3626 1.2513 21.7478 0.996582 21.1065 0.996582Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5242 5.76904L12.6513 12.1677C12.5485 12.2281 12.4336 12.2649 12.3148 12.2754C12.1961 12.286 12.0765 12.2702 11.9647 12.229L11.8325 12.1677L0.959595 5.77226V16.3084C0.959595 16.9495 1.21431 17.5645 1.66771 18.0178C2.1211 18.4712 2.73603 18.7259 3.37723 18.7259H21.1065C21.7478 18.7259 22.3626 18.4712 22.8161 18.0178C23.2694 17.5645 23.5242 16.9495 23.5242 16.3084V5.76904Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.73c2bfb1ee2fe7b350e0986f59f9629d.svg";
export { ForwardRef as ReactComponent };